import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IHideRecommendationParams } from '../../../spacesPlatform/utils/actionParams';

export class UndoHideRecommendationRequest extends Request<IHideRecommendationParams, IResult> {
  constructor(params: IHideRecommendationParams) {
    super('unhideRecommendation', params);
  }
}
